module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"credit_balance":"Credit balance","reload_now_to":"Reload now to","send_out_reminders":"send out reminders"},"id":{"credit_balance":"Saldo kredit","reload_now_to":"Muat lagi sekarang untuk","send_out_reminders":"dapat mengirim pengingat"}}')
  delete Component.options._Ctor
}
